import { Directive, Output, Input, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {
  }

  @Output()
  public clickOutside = new EventEmitter<MouseEvent>();
  @Input()
  public clickOutsideExclude: Array<string> = [];

  private isDescendant(parent, child) {
    let node = child.parentNode;

    while (node) {
      if (node === parent) {
        return true;
      }

      node = node.parentNode;
    }
    
    let excludeElementClicked = false;
    
    this.clickOutsideExclude.forEach(elementSelector => {
      let elementsToExclude = Array.from(document.querySelectorAll(elementSelector));
      
      if (typeof elementsToExclude !== 'undefined' && elementsToExclude !== null) {
        elementsToExclude.forEach((elementToExclude) => {
          if (child === elementToExclude) {
            excludeElementClicked = true;
            return;
          }
        });
      }
    });
    
    if (excludeElementClicked) {
      return true;
    }

    return false;
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement || targetElement === this._elementRef.nativeElement) {
      return;
    }

    const clickedInside = this.isDescendant(this._elementRef.nativeElement, targetElement);

    if (!clickedInside) {
      this.clickOutside.emit(event);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/global/clickOutside/clickOutside.directive.ts